import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  UpdateTasksMutation,
  UpdateTasksMutationVariables,
  UpdateTasksDocument,
  FetchTasksByTenderIdDocument,
} from "@/graphql/__generated__/graphql";

export default function useUpdateTasksMutationHook(): {
  updateTasksMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);
  const { tenderID } = useParams<{ tenderID: string }>();

  const [updateTasksMutation, { loading, error }] = useMutation<UpdateTasksMutation, UpdateTasksMutationVariables>(
    UpdateTasksDocument, {
      onCompleted() {
        toast(CustomToastComponent, {
          toastId: "tasks-updated-success",
          data: {
            title: t("toasts.tasksupdated"),
            type: "success",
          },
        });
      },
      refetchQueries: [
        {
          query: FetchTasksByTenderIdDocument,
          variables: { tenderId: Number(tenderID) },
        },
      ],
    });

  return {
    updateTasksMutation,
    loading,
    error,
  };
}
